import { z } from 'zod'

export const verificationCodeSchema = z
  .string()
  .nonempty('验证码不能为空')
  .regex(/\d{6}/, '验证码格式不正确')
  .default('')
